// Comprehensive registry of all 36+ supported blockchain networks in SecureWatch
export const ALL_NETWORKS = [
  // ── Featured Major Chains ──
  {
    id: "1",
    name: "Ethereum Mainnet",
    tag: "ETH",
    chainId: 1,
    desc: "Layer 1 Proof of Stake",
    badgeColor: "bg-blue-50 text-blue-700 border-blue-200",
    category: "Featured",
    isFeatured: true,
  },
  {
    id: "42161",
    name: "Arbitrum One",
    tag: "ARB",
    chainId: 42161,
    desc: "Optimistic Rollup · Nitro",
    badgeColor: "bg-cyan-50 text-cyan-700 border-cyan-200",
    category: "Featured",
    isFeatured: true,
  },
  {
    id: "8453",
    name: "Base",
    tag: "BASE",
    chainId: 8453,
    desc: "Coinbase L2 · OP Stack",
    badgeColor: "bg-indigo-50 text-indigo-700 border-indigo-200",
    category: "Featured",
    isFeatured: true,
  },
  {
    id: "56",
    name: "BNB Smart Chain",
    tag: "BSC",
    chainId: 56,
    desc: "Binance EVM ecosystem",
    badgeColor: "bg-amber-50 text-amber-700 border-amber-200",
    category: "Featured",
    isFeatured: true,
  },
  {
    id: "137",
    name: "Polygon Mainnet",
    tag: "POLYGON",
    chainId: 137,
    desc: "PoS Sidechain & zkEVM",
    badgeColor: "bg-purple-50 text-purple-700 border-purple-200",
    category: "Featured",
    isFeatured: true,
  },
  {
    id: "43114",
    name: "Avalanche C-Chain",
    tag: "AVAX",
    chainId: 43114,
    desc: "Snowman Consensus",
    badgeColor: "bg-rose-50 text-rose-700 border-rose-200",
    category: "Featured",
    isFeatured: true,
  },
  {
    id: "10",
    name: "Optimism",
    tag: "OP",
    chainId: 10,
    desc: "OP Mainnet Superchain",
    badgeColor: "bg-red-50 text-red-700 border-red-200",
    category: "Featured",
    isFeatured: true,
  },
  {
    id: "1300",
    name: "Algorand Mainnet",
    tag: "ALGO",
    chainId: 1300,
    desc: "Pure PoS AVM Architecture",
    badgeColor: "bg-slate-100 text-slate-800 border-slate-300",
    category: "Featured",
    isFeatured: true,
  },

  // ── Layer 2 & Rollup Ecosystem ──
  {
    id: "59144",
    name: "Linea",
    tag: "LINEA",
    chainId: 59144,
    desc: "Consensys zkEVM Rollup",
    badgeColor: "bg-zinc-100 text-zinc-800 border-zinc-300",
    category: "Layer 2",
    isFeatured: false,
  },
  {
    id: "534352",
    name: "Scroll",
    tag: "SCROLL",
    chainId: 534352,
    desc: "Bytecode-level zkEVM",
    badgeColor: "bg-orange-50 text-orange-700 border-orange-200",
    category: "Layer 2",
    isFeatured: false,
  },
  {
    id: "324",
    name: "ZkSync Era",
    tag: "ZKSYNC",
    chainId: 324,
    desc: "ZK Rollup with Native AA",
    badgeColor: "bg-violet-50 text-violet-700 border-violet-200",
    category: "Layer 2",
    isFeatured: false,
  },
  {
    id: "1101",
    name: "Polygon zkEVM",
    tag: "zkEVM",
    chainId: 1101,
    desc: "Zero-Knowledge EVM L2",
    badgeColor: "bg-purple-50 text-purple-700 border-purple-200",
    category: "Layer 2",
    isFeatured: false,
  },
  {
    id: "169",
    name: "Manta Pacific",
    tag: "MANTA",
    chainId: 169,
    desc: "Modular ZK Applications",
    badgeColor: "bg-teal-50 text-teal-700 border-teal-200",
    category: "Layer 2",
    isFeatured: false,
  },
  {
    id: "204",
    name: "opBNB",
    tag: "opBNB",
    chainId: 204,
    desc: "High throughput BSC L2",
    badgeColor: "bg-yellow-50 text-yellow-700 border-yellow-200",
    category: "Layer 2",
    isFeatured: false,
  },
  {
    id: "288",
    name: "Boba Network",
    tag: "BOBA",
    chainId: 288,
    desc: "Hybrid Compute L2",
    badgeColor: "bg-lime-50 text-lime-700 border-lime-200",
    category: "Layer 2",
    isFeatured: false,
  },
  {
    id: "1868",
    name: "Soneium",
    tag: "SONEIUM",
    chainId: 1868,
    desc: "Sony Block Solutions L2",
    badgeColor: "bg-sky-50 text-sky-700 border-sky-200",
    category: "Layer 2",
    isFeatured: false,
  },
  {
    id: "185",
    name: "Mint",
    tag: "MINT",
    chainId: 185,
    desc: "L2 for NFT Ecosystem",
    badgeColor: "bg-emerald-50 text-emerald-700 border-emerald-200",
    category: "Layer 2",
    isFeatured: false,
  },

  // ── EVM & High-Performance Alt L1s ──
  {
    id: "1116",
    name: "CoreDAO",
    tag: "CORE",
    chainId: 1116,
    desc: "Satoshi Plus Consensus",
    badgeColor: "bg-amber-50 text-amber-700 border-amber-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "146",
    name: "Sonic",
    tag: "SONIC",
    chainId: 146,
    desc: "Sub-second 10k TPS EVM",
    badgeColor: "bg-orange-50 text-orange-700 border-orange-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "100",
    name: "Gnosis (xDai)",
    tag: "GNO",
    chainId: 100,
    desc: "Decentralized Payments",
    badgeColor: "bg-emerald-50 text-emerald-700 border-emerald-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "250",
    name: "Fantom",
    tag: "FTM",
    chainId: 250,
    desc: "Lachesis DAG Consensus",
    badgeColor: "bg-blue-50 text-blue-700 border-blue-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "42220",
    name: "Celo",
    tag: "CELO",
    chainId: 42220,
    desc: "Carbon-negative Mobile EVM",
    badgeColor: "bg-green-50 text-green-700 border-green-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "25",
    name: "Cronos",
    tag: "CRO",
    chainId: 25,
    desc: "Crypto.com EVM Chain",
    badgeColor: "bg-blue-50 text-blue-700 border-blue-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "592",
    name: "Astar",
    tag: "ASTR",
    chainId: 592,
    desc: "Multi-VM Smart Contracts",
    badgeColor: "bg-purple-50 text-purple-700 border-purple-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "7000",
    name: "Zeta Chain",
    tag: "ZETA",
    chainId: 7000,
    desc: "Omnichain Smart Contracts",
    badgeColor: "bg-green-50 text-green-700 border-green-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "47763",
    name: "Neo X",
    tag: "NEOX",
    chainId: 47763,
    desc: "MEV-resistant EVM",
    badgeColor: "bg-emerald-50 text-emerald-700 border-emerald-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "1625",
    name: "Gravity Chain",
    tag: "GRAV",
    chainId: 1625,
    desc: "Galxe Settlement Chain",
    badgeColor: "bg-indigo-50 text-indigo-700 border-indigo-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "50",
    name: "XDC Network",
    tag: "XDC",
    chainId: 50,
    desc: "Enterprise Trade Finance",
    badgeColor: "bg-blue-50 text-blue-700 border-blue-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "2040",
    name: "Vanar",
    tag: "VANAR",
    chainId: 2040,
    desc: "Entertainment & Gaming EVM",
    badgeColor: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "143",
    name: "Monad",
    tag: "MONAD",
    chainId: 143,
    desc: "Parallel Execution EVM",
    badgeColor: "bg-purple-50 text-purple-700 border-purple-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "1313161554",
    name: "Aurora",
    tag: "AURORA",
    chainId: 1313161554,
    desc: "NEAR Protocol EVM",
    badgeColor: "bg-teal-50 text-teal-700 border-teal-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "747474",
    name: "Katana",
    tag: "KATANA",
    chainId: 747474,
    desc: "High Performance DeFi",
    badgeColor: "bg-red-50 text-red-700 border-red-200",
    category: "Alt L1",
    isFeatured: false,
  },
  {
    id: "43111",
    name: "Hemi",
    tag: "HEMI",
    chainId: 43111,
    desc: "Modular Bitcoin & EVM",
    badgeColor: "bg-amber-50 text-amber-700 border-amber-200",
    category: "Alt L1",
    isFeatured: false,
  },

  // ── Testnets ──
  {
    id: "11155111",
    name: "Sepolia Testnet",
    tag: "SEP",
    chainId: 11155111,
    desc: "Ethereum Proof of Authority",
    badgeColor: "bg-slate-100 text-slate-700 border-slate-300",
    category: "Testnets",
    isFeatured: false,
  },
  {
    id: "80002",
    name: "Polygon Amoy",
    tag: "AMOY",
    chainId: 80002,
    desc: "Polygon PoS Testnet",
    badgeColor: "bg-slate-100 text-slate-700 border-slate-300",
    category: "Testnets",
    isFeatured: false,
  },
  {
    id: "1301",
    name: "Algorand Testnet",
    tag: "ALGO-T",
    chainId: 1301,
    desc: "Algorand Test Sandbox",
    badgeColor: "bg-slate-100 text-slate-700 border-slate-300",
    category: "Testnets",
    isFeatured: false,
  },
];

export const FEATURED_NETWORKS = ALL_NETWORKS.filter((n) => n.isFeatured);
export const OTHER_NETWORKS = ALL_NETWORKS.filter((n) => !n.isFeatured);
